import { isWithinInterval, addHours } from 'date-fns';
export function isWithinNext24Hours(date) {
    const now = new Date();
    return isWithinInterval(date, {
        start: now,
        end: addHours(now, 24),
    });
}
export const rangeWindowSize = (start, end) => end >= start ? end - start + 1 : 31 - start + 1 + end;
